import { graphql } from '../../../../graphql/generated';

export const UPDATE_TEST_TUBE_MUTATION = graphql(`
  mutation UpdateTestTube($id: ID!, $input: TestTubeUpdateInput!) {
    updateTestTube(id: $id, input: $input) {
      id
    }
  }
`);
